// extracted by mini-css-extract-plugin
module.exports = {"cropperModal":"CropperModal_cropperModal__1YtmC","cropper":"CropperModal_cropper__2hyBQ","circleCropper":"CropperModal_circleCropper__1MsjC"};